<template>
    <div>
        <div class="zonePrice d-md-flex flex-md-wrap justify-content-md-start">
            <ponroy-cart-reference-card
                    v-for="reference in references"
                    :key="reference.id"
                    :name="reference.name"
                    :value="reference.id"
                    :isRecommanded="reference.recommended_cure"
                    :numberOfDays="reference.number_of_days"
                    :referenceCode="reference.id"
                    :isUnavailable="isUnavailable"
                    :price="reference.discounted_price > 0 ? reference.discounted_price : reference.price"
                    :basePrice="reference.price"
                    :advantageName="reference.advantage_name"
                    v-model="orderable.id"

            ></ponroy-cart-reference-card>
        </div>

        <div class="actions text-center text-lg-left" v-if="!isUnavailable">
            <button class="btn btn-primary btnAddCart hvr-grow float-lg-right" type="button" @click="update()">Ajouter au panier</button>
            <ponroy-cart-quantity v-model="quantity"></ponroy-cart-quantity>
            <div class="clearfix"></div>
        </div>
        <div v-else>
            <slot name="isUnavailable"></slot>
        </div>


    </div>
</template>

<script>

    import {mapActions, mapState} from 'vuex';
    import store from '../store';

    const CartAdd = {
        name: 'ponroy-cart-add',
        store,
        data() {
            return {
                orderable: {
                    repository: this.repository,
                    id : this.getChecked(),
                },
                quantity: 1,
            }
        },
        props: {
            repository: String,
            references: Array,
            isUnavailable: Boolean,
        },
        methods: {
            ...mapActions('cart', [
                'addToCart',
            ]),
            ...mapActions('cart', {
                toggle : 'toggleWidget',
            }),
            update() {
                const {orderable, quantity} = this;
                if (orderable.id && quantity) {
                    this.addToCart({orderable, quantity});
                    this.toggle({isNotification: true});
                }
            },
            getChecked() {
                let v = null;

                this.references.forEach(function(el){
                    if (el.recommended_cure && null === v) {
                        v = el.id;
                    }
                });

                if (null === v) {
                    v = this.references[0].id;
                }

                return v;
            },
        }
    };

    export default CartAdd;

</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/CartAdd.vue